var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right"},[(_vm.role === 'viewer')?_c('span',{staticClass:"badge badge-secondary"},[_vm._v("Viewer")]):_vm._e(),(_vm.role === 'editor')?_c('span',{staticClass:"badge badge-primary"},[_vm._v("Editor")]):_vm._e(),(_vm.role === 'admin')?_c('span',{staticClass:"badge badge-warning"},[_vm._v("Admin")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }